<!-- TabsComponent.vue (Child Component) -->
<template>
  <div>
    <div
      class="tabs-container"
      :style="tabsContainerStyles()"
      style="position: relative"
    >
      <div
        v-for="(tab, index) in tabsData.options"
        :key="index"
        @click="setActiveTab(index)"
        :class="{ [!calculatorData.isTata ? 'active2' : 'active']: activeTab === index }"
        class="options"
        :style="getStyles()"
      >
        {{ tab.tab_name }}

        <span>
          <el-popover placement="top-start" trigger="hover" :width="358" class="tooltipClass" effect="dark">
            <template #reference>
              <div :class="iIconStyles(index)">
                <span :class="iLetterStyles(index)">
                  <i> i</i>
                </span>
              </div>
            </template>
            <p>{{ tab.description }}</p>
          </el-popover>
        </span>
      </div>
    </div>
    <div class="paddingForMD">
      <DynamicDataComponent
        :data="tabsData.options[activeTab].tab_fields"
        :type="type"
        @offGridActive="offGridActive"
        @generateData="generateData"
        :showContent="showContent"
        :isCalculateRoi="isCalculateRoi"
      />
    </div>
  </div>
</template>

<script setup>
import DynamicDataComponent from "./DynamicDataComponent.vue";
import { solarCalculatorStore } from "../../../../store/solarCalculator";
import { onMounted, ref, watch } from "vue";

const props = defineProps(["tabsData", "type", "screen", "fetching_error","showContent","isCalculateRoi"]);
const emits = defineEmits([
  "scrollToTop",
  "generateResults",
  "handleErrorResponse",
]);
const store = solarCalculatorStore();
const calculatorData = store.CALCULATOR_DATA_STATE;
let activeTab = ref(calculatorData.active_tab);

const generateData = () => {
  emits("generateResults");
};

const setActiveTab = (index) => {
  activeTab.value = index;
  if (activeTab.value === 0) {
    store.UPDATE_CALCULATOR_DATA("on_grid", "SelectedGrid");
    store.UPDATE_CALCULATOR_DATA(0, "active_tab");
    emits("generateResults");
  }
  if (activeTab.value === 1) {
    store.UPDATE_CALCULATOR_DATA("off_grid", "SelectedGrid");
    store.UPDATE_CALCULATOR_DATA(1, "active_tab");
    emits("generateResults");
  }
};

const offGridActive = () => {
  setActiveTab(1);
};

const iIconStyles = (index) => {
  if (activeTab.value === index) {
    return "i_icon";
  } else {
    return "i_icon_not_active";
  }
};

const iLetterStyles = (index) => {
  if (activeTab.value === index) {
    return "i_content";
  } else {
    return "i_content_not_active";
  }
};

const getStyles = () => {
  if (props.screen === "full") {
    return {
      display: "flex",
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "8px",

      padding: "15px",

      cursor: "pointer",
    };
  } else {
    return {
      display: "flex",
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "8px",

      padding: "15px",
      margin: "8px",
      cursor: "pointer",
    };
  }
};

const tabsContainerStyles = () => {
  if (props.screen === "full") {
    return {
      display: "flex",
      color: "black",
      backgroundColor: "white",
      boxShadow: "0px 0px 6px 0px rgba(0, 0, 0, 0.15)",
      borderRadius: "8px",
    };
  } else {
    return {
      display: "flex",
      color: "#777777",
      backgroundColor: "#E8EDF2",
      fontFamily: "Arial",
      fontSize: "20px",
      fontStyle: "normal",
      fontWeight: "700",
      lineHeight: "normal",
      borderRadius: "8px",
    };
  }
};
</script>

<style scoped>
.active {
  background-color: #006eaf;
  color: white;
}

.active2 {
  background-color: #409EFF;
  color: white;
}

.i_icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 15px;
  width: 15px;
  background-color: white;
  border-radius: 50%;
  margin-left: 5px;
  cursor: pointer;
}
.i_icon_not_active {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 15px;
  width: 15px;
  background-color: #777;
  border-radius: 50%;
  margin-left: 5px;

  cursor: pointer;
}
.i_content {
  font-size: 12px;
  font-weight: 800;
  font-family: cursive;
  color: #006eaf;
  padding-right: 2px;
}
.i_content_not_active {
  font-size: 12px;
  font-weight: 800;
  font-family: cursive;
  color: white;
  padding-right: 2px;
}

@media (max-width: 1180px) {
  .tabs-container{
    background-color: white !important;
    
  }
  .active {
  background-color: transparent;
  color: #006EAF;
  border-bottom: 2px solid #006EAF;
  border-radius: 0 !important;

}

.active2 {
  background-color: transparent;
  color: #409EFF;
  border-bottom: 2px solid #409EFF;
  border-radius: 0 !important;
}


.i_icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 15px;
  width: 15px;
  background-color: #777;
  border-radius: 50%;
  margin-left: 5px;
  cursor: pointer;
}
.i_icon_not_active {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 15px;
  width: 15px;
  background-color: #777;
  border-radius: 50%;
  margin-left: 5px;

  cursor: pointer;
}
.i_content {
  font-size: 12px;
  font-weight: 800;
  font-family: cursive;
  color: white;
  padding-right: 2px;
}
.i_content_not_active {
  font-size: 12px;
  font-weight: 800;
  font-family: cursive;
  color: white;
  padding-right: 2px;
}

}

@media (max-width: 800px) {
  .tabs-container{
    background-color: white !important;
    
  }
  .active {
  background-color: transparent;
  color: #006EAF;
  border-bottom: 2px solid #006EAF !important;
  border-radius: 0 !important;

}

.active2 {
  background-color: transparent;
  color: #409EFF;
  border-bottom: 2px solid #409EFF !important;
  border-radius: 0 !important;
}

.i_icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 15px;
  width: 15px;
  background-color: #777;
  border-radius: 50%;
  margin-left: 5px;
  cursor: pointer;
}
.i_icon_not_active {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 15px;
  width: 15px;
  background-color: #777;
  border-radius: 50%;
  margin-left: 5px;

  cursor: pointer;
}
.i_content {
  font-size: 12px;
  font-weight: 800;
  font-family: cursive;
  color: white;
  padding-right: 2px;
}
.i_content_not_active {
  font-size: 12px;
  font-weight: 800;
  font-family: cursive;
  color: white;
  padding-right: 2px;
}

.paddingForMD {
  padding: 16px;
  padding-top: 0px;
  height: calc(100vh - 160px);
  overflow-y: scroll;
}

.tabs-container {
  font-size: 14px !important;
}

.options {
  margin: 0 !important;
  border-bottom: 2px solid #ccc;
  border-radius: 0px !important;
}
}
</style>
